import { uniqBy } from "lodash";

import { errorNotificationWrapper } from "../../../logic/helpers/NotificationService";
import { GetUserInfoRes } from "./types";

export default abstract class GetUserInfoService {
  usersInfos: Array<GetUserInfoRes> = []

  isLoading = false

  targetId: string | number

  constructor(targetId: string | number) {
    this.targetId = targetId
  }

  abstract getUsersInfoReq(users: Array<number | string>): Promise<{ data: Array<GetUserInfoRes> }>

  getUsersInfos(users: Array<number | string>) {
    this.isLoading = true

    return this.getUsersInfoReq(users)
        .then(({ data }) => {
          this.usersInfos = uniqBy(this.usersInfos.concat(data), (val) => val.info?.id);

          return data;
        })
        .catch(error => errorNotificationWrapper('', error))
        .finally(() => this.isLoading = false)
  }
}
